const socialLinks = [
  {
    icon: 'ri-instagram-line',
    label: 'Instagram',
    href: 'https://instagram.com',
    color: 'hover:text-[#E1306C]',
  },
  {
    icon: 'ri-tiktok-line',
    label: 'TikTok',
    href: 'https://tiktok.com',
    color: 'hover:text-white',
  },
  {
    icon: 'ri-youtube-line',
    label: 'YouTube',
    href: 'https://youtube.com',
    color: 'hover:text-[#FF0000]',
  },
  {
    icon: 'ri-whatsapp-line',
    label: 'WhatsApp',
    href: 'https://wa.me/903222286464',
    color: 'hover:text-[#25D366]',
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/8 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Top */}
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-10 mb-12">
          {/* Logo & Slogan */}
          <div className="text-center md:text-left">
            <img
              src="https://public.readdy.ai/ai/img_res/785265ea-7d68-45e2-baa3-c310ca661c92.png"
              alt="Logo"
              className="h-12 w-auto object-contain mx-auto md:mx-0 mb-3"
            />
            <p
              className="text-[#FF4500] uppercase text-2xl font-black"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              Tarzın Cebinde.
            </p>
            <p className="text-white/40 text-sm mt-2 max-w-xs">
              Adana'nın en iyi telefon aksesuar mağazası. Kişiye özel baskı ve daha fazlası.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <p className="text-white/30 text-xs uppercase tracking-widest font-semibold mb-1">Hızlı Erişim</p>
            {[
              { label: 'Ürünler', href: '#urunler' },
              { label: 'Özel Baskı', href: '#ozel-baski' },
              { label: 'Neden Biz?', href: '#neden-biz' },
              { label: 'Mağaza', href: '#magaza' },
            ].map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-white/50 hover:text-[#FF4500] transition-colors text-sm cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <p className="text-white/30 text-xs uppercase tracking-widest font-semibold mb-1">İletişim</p>
            <a
              href="tel:+903222286464"
              className="text-white/50 hover:text-white transition-colors text-sm cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-phone-line w-3 h-3 flex items-center justify-center" />
              (0322) 228 64 64
            </a>
            <a
              href="https://wa.me/903222286464"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/50 hover:text-[#25D366] transition-colors text-sm cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-whatsapp-line w-3 h-3 flex items-center justify-center" />
              WhatsApp
            </a>
            <p className="text-white/50 text-sm flex items-center gap-2">
              <i className="ri-map-pin-line w-3 h-3 flex items-center justify-center" />
              Bülent Angın Blv. No:76, Seyhan/Adana
            </p>
          </div>

          {/* Social */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <p className="text-white/30 text-xs uppercase tracking-widest font-semibold mb-1">Sosyal Medya</p>
            <div className="flex gap-3">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className={`w-10 h-10 flex items-center justify-center bg-white/8 hover:bg-white/15 rounded-xl text-white/50 ${s.color} transition-all cursor-pointer`}
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-6" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-white/25 text-xs">
          <p>© {new Date().getFullYear()} Telefon Aksesuar. Tüm hakları saklıdır.</p>
          <p>Adana, Türkiye 🇹🇷</p>
        </div>
      </div>
    </footer>
  );
}
